














































































































import Vue from 'vue'
import UpdateChecker from './_components/UpdateChecker.vue'
import MobileBtn from './_components/MobileBtn.vue'
import ContentPage from '../nav/pages/ExtraContent/index.vue'
import AboutPage from '../nav/pages/About.vue'
import HelpPage from '../nav/pages/Help.vue'
import OptionsPage from '../nav/pages/Options/index.vue'

export default Vue.extend({
  name: 'landing-page-mobile',
  components: {
    UpdateChecker,
    MobileBtn,
    ContentPage,
    AboutPage,
    HelpPage,
    OptionsPage,
  },
  data: () => ({
    pilotLoading: false,
  }),
  beforeRouteLeave(to, from, next) {
    if (to.path === '/pilot_management') this.pilotLoading = true
    next()
  },
})
